import includes from 'lodash-es/includes.js'

export const filterAlerts = (validation, key) => {
  if (validation && validation.controls) {
    const alertIds = validation.controls[key] || []
    return validation.alerts.filter(alert => includes(alertIds, alert.id))
  }
  return []
}
